
import Vue from 'vue';
import { api, Mapping, MappingExpression } from '@/services/api';
import FileInput from '@/components/FileInput.vue';
import { exportFile, readFile } from '@/services/fileHelper';

export default Vue.extend({
    components: {
        FileInput
    },
    data() {
        return {
            selectedSource: "Poste",
            mappings: [] as Mapping[],
            sources: [] as string[],
            filter: ""
        }
    },
    async mounted() {
        await this.refreshMappings();
    },
    methods: {
        async refreshMappings() {
            const tasks = [
                api.getMappings().then(res => this.mappings = res),
                api.getSources().then(res => this.sources = res)
            ];
            await Promise.all<(Promise<Mapping[]> | Promise<string[]>)>(tasks);
            for (const source of this.sources) {
                if (!this.mappings.find(e => e.source === source)) {
                    this.mappings.push({
                        source,
                        expressions: []
                    })
                }
            }
            if (!this.sources.includes(this.selectedSource) && this.sources.length > 0) {
                this.selectedSource = this.sources[0];
            }
        },
        async loadMappingFile(file: File) {
            const data = await readFile(file);
            this.mappings = JSON.parse(data) as Mapping[];
            this.sources = this.mappings.map(m => m.source);
            if (!this.sources.includes(this.selectedSource) && this.sources.length > 0) {
                this.selectedSource = this.sources[0];
            }
        },
        async exportMappings() {
            await exportFile(JSON.stringify(this.mappings, null, 2), "mappings.json");
        },
        async saveMappings() {
            for (const mapping of this.mappings) {
                await api.setMapping(mapping);
            }
            await this.refreshMappings();
        },
        addMapping() {
            if (this.currentMapping) {
                this.currentMapping.expressions.push({
                    expression: "",
                    template: ""
                });
            }
        },
        deleteExpression(expression: MappingExpression) {
            if (this.currentMapping) {
                const index = this.currentMapping.expressions.indexOf(expression);
                if (index >= 0) {
                    this.currentMapping.expressions.splice(index, 1);
                }
            }
        },
        expressionCount(source: string): number {
            const mapping = this.mappings.find(e => e.source === source);
            return mapping ? mapping.expressions.length : 0;
        },
        expressionKey(expression: MappingExpression, index: number): string {
            return `${index}:${expression.expression}:${expression.template}`;
        }
    },
    computed: {
        currentMapping(): Mapping | null {
            const current = this.mappings.find(e => e.source === this.selectedSource);
            return current || null;
        },
        filteredExpressions(): MappingExpression[] {
            if (!this.currentMapping) {
                return [];
            }
            const filter = this.filter.trim().toLowerCase();
            if (filter.length === 0) {
                return this.currentMapping.expressions;
            }
            return this.currentMapping.expressions.filter(e =>
                e.expression.toLowerCase().includes(filter) ||
                e.template.toLowerCase().includes(filter)
            );
        }
    }
})
